import React from "react";

const PillToggleGroup = ({
	options = [],
	value,
	onChange,
	multiple = false,
	className = "",
	ariaLabel = "Selector",
	variant = "default",
}) => {
	const selectedValues = multiple
		? Array.isArray(value)
			? value
			: []
		: [value];

	const isSelected = (optionValue) => selectedValues.includes(optionValue);

	const handleClick = (optionValue) => {
		if (!onChange) return;

		if (!multiple) {
			onChange(optionValue);
			return;
		}

		const nextValues = isSelected(optionValue)
			? selectedValues.filter((item) => item !== optionValue)
			: [...selectedValues, optionValue];

		onChange(nextValues);
	};

	return (
		<div
			className={`pill-toggle-group pill-toggle-group--${variant} ${className}`}
			role="group"
			aria-label={ariaLabel}
		>
			{options.map((option) => (
				<button
					key={option.value}
					type="button"
					className={`pill-toggle-group__item ${
						isSelected(option.value) ? "is-active" : ""
					}`}
					onClick={() => handleClick(option.value)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
};

export default PillToggleGroup;
